module.exports = __webpack_public_path__ + "img/LeftWhite.4e5469eb.svg";